import React from "react";
import { Routes, Route } from "react-router-dom";

import WebsiteLayout from "../layouts/WebsiteLayout.jsx";

import Home from "../pages/public/Home.jsx";
import About from "../pages/public/About.jsx";
import Courses from "../pages/public/Courses.jsx";
import Pricing from "../pages/public/Pricing.jsx";
import Testimonials from "../pages/public/Testimonials.jsx";
import Contact from "../pages/public/Contact.jsx";
import Privacy from "../pages/public/Privacy.jsx";
import Terms from "../pages/public/Terms.jsx";
import FloatingActions from "../components/FloatingActions.jsx";

const WebsiteRoute = () => {
    return (
       <>
        <FloatingActions/>
        <Routes>
            
            {/* Website Layout with Navbar + Footer */}
            
            <Route element={<WebsiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/testimonials" element={<Testimonials />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Privacy/>}/>
                <Route path="/terms" element={<Terms/>}/>
            </Route>
        </Routes>
        </>
    );
};

export default WebsiteRoute;
